import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"; // this is needed!
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateService,
  TranslateModule,
  TranslateLoader
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { ShellModule } from "./shell/shell.module";
import { appRouting } from "./app.routing";
import { PageNotFoundModule } from "./shell/page-not-found/page-not-found.module";
import { HttpModule } from "@angular/http";
import { NotificationService } from "./core/services/notification/notification.service";
import { LoginModule } from "./login/login.module";
import { SharedTemplateModule } from "./shared-template/shared-template.module";
import { BsDatepickerModule } from "ngx-bootstrap";
import { IssueService } from "./issues/issue.service";
import { ProjectService } from "./projects/projects.service";
// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule,
    LoginModule,
    SharedTemplateModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ShellModule,
    HttpModule,
    appRouting,
    PageNotFoundModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [NotificationService, IssueService, ProjectService],
  bootstrap: [AppComponent]
})
export class AppModule { }
